import { useQuery } from '@tanstack/react-query';
import { getIssuesGridData } from '../services/IIMIssuesService';
import { iimReviewKeys } from './queryKeys';
export default function useIIMIssuesGrid(inspectionId, filters, sortBy, sortDirection, groupBy, page, pageSize, modeIA, options) {
    const params = {
        inspectionId,
        statuses: filters.statuses.length > 0 ? filters.statuses : undefined,
        issueTypes: filters.issueTypes.length > 0 ? filters.issueTypes : undefined,
        inspectableTypes: filters.inspectableTypes.length > 0 ? filters.inspectableTypes : undefined,
        impact: filters.impact,
        search: filters.search || undefined,
        sortBy: sortBy || undefined,
        sortDirection: sortBy ? sortDirection : undefined,
        groupBy: groupBy !== 'none' ? groupBy : undefined,
        page,
        pageSize
    };
    const paramsKey = JSON.stringify(params);
    return useQuery({
        queryKey: iimReviewKeys.issuesGrid(inspectionId, paramsKey),
        queryFn: () => getIssuesGridData(params),
        select: (response) => ({
            issues: response.issues,
            runStatus: response.runStatus,
            filterOptions: response.filterOptions,
            pagination: response.pagination
        }),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        retry: 3,
        enabled: (options === null || options === void 0 ? void 0 : options.enabled) !== false,
        keepPreviousData: true
    });
}
